import type { Translations } from './en.js';

const zhHant: Translations = {
  ok: '確認',
  cancel: '取消',
  close: '關閉',
  confirm: '確認',
  retry: '重試',
  back: '返回',
  settings: '設定',
  language: '語言',
  score: '分數',
  level: '等級',
  game_over: '遊戲結束',
  restart: '重新開始',
  pause: '暫停',
  resume: '繼續',
  settings_sound: '音效',
  settings_music: '音樂',
  settings_reset: '重置遊戲',
  settings_reset_confirm: '確定重置所有進度？',
  ad_watch: '觀看廣告',
  ad_reward: '免費獎勵',
  ad_loading: '廣告載入中...',
  ad_reward_received: '已獲得獎勵！',
  ad_not_completed: '廣告未完成',
  offline_title: '歡迎回來！',
  offline_earned: '離線期間獲得',
  sp: 'SP',
  fame: '聲望',
  building_tab: '建築',
  ghosts_tab: '鬼魂',
  shop_tab: '商店',
  prestige_tab: '聲望',
  training_tab: '訓練',
  facilities_tab: '附設',
  reviews_tab: '評論',
  floor_label: '{n}樓',
  buy_floor: '購買樓層',
  buy_floor_cost: '購買樓層 ({sp} SP)',
  unlock_slot: '解鎖空位',
  unlock_slot_cost: '解鎖空位 ({sp} SP)',
  build_room: '建造房間',
  upgrade_room: '升級房間',
  upgrade_room_cost: '升級 ({sp} SP)',
  room_empty: '空置',
  room_locked: '已鎖定',
  no_ghost: '無鬼魂',
  assign_ghost: '指派鬼魂',
  visitors_floor: '此樓的訪客',
  add_floor: '新增樓層',
  add_floor_cost: '+ 新樓層 ({sp} SP)',
  menu_tab: '選單',
  room_dark_corridor: '黑暗走廊',
  room_dark_corridor_desc: '心理恐懼 +30%',
  room_mirror_room: '鏡子房',
  room_mirror_room_desc: '視覺 +25%、心理 +15%',
  room_dungeon: '地牢',
  room_dungeon_desc: '心理 +20%、物理 +20%',
  room_graveyard: '墓地房間',
  room_graveyard_desc: '心理恐懼 +40%',
  room_lab: '實驗室',
  room_lab_desc: '視覺 +30%、物理 +20%',
  room_library: '圖書館',
  room_library_desc: '心理 +35%、聽覺 +15%',
  room_coffin_room: '棺材房',
  room_coffin_room_desc: '視覺 +30%、心理 +20%',
  room_doll_room: '人偶房',
  room_doll_room_desc: '視覺 +20%、心理 +35%',
  room_kitchen: '詛咒廚房',
  room_kitchen_desc: '物理 +30%、聽覺 +20%',
  room_bathroom: '鬧鬼浴室',
  room_bathroom_desc: '心理 +30%、聽覺 +25%',
  room_funhouse: '鏡子迷宮',
  room_funhouse_desc: '視覺+35%, 心理+20%',
  room_trapeze_room: '空中鞦韆室',
  room_trapeze_room_desc: '物理+30%, 視覺+15%',
  room_freak_show: '畸形秀',
  room_freak_show_desc: '視覺+40%, 心理+30%',
  room_sacrifice_altar: '祭壇',
  room_sacrifice_altar_desc: '心理+40%, 視覺+20%',
  room_treasure_vault: '寶物庫',
  room_treasure_vault_desc: '心理+20%, 聽覺+20%',
  room_underground_river: '地下河',
  room_underground_river_desc: '聽覺+30%, 心理+20%',
  room_curse_chamber: '詛咒之室',
  room_curse_chamber_desc: '心理+45%, 物理+15%',
  room_mummy_tomb: '木乃伊墓',
  room_mummy_tomb_desc: '視覺+30%, 心理+30%',
  room_captain_cabin: '船長室',
  room_captain_cabin_desc: '心理+30%, 視覺+20%',
  room_cargo_hold: '貨艙',
  room_cargo_hold_desc: '物理+25%, 聽覺+20%',
  room_davy_jones_locker: '深海閻王櫃',
  room_davy_jones_locker_desc: '心理+35%, 視覺+25%',
  room_brig: '禁閉室',
  room_brig_desc: '物理+30%, 心理+20%',
  room_crows_nest: '烏鴉巢',
  room_crows_nest_desc: '物理+35%, 視覺+20%',
  room_mine_shaft: '礦坑通道',
  room_mine_shaft_desc: '物理+30%, 聽覺+20%',
  room_crystal_cave: '水晶洞',
  room_crystal_cave_desc: '視覺+35%, 聽覺+15%',
  room_explosives_storage: '炸藥庫',
  room_explosives_storage_desc: '物理+40%, 聽覺+25%',
  room_underground_lake: '地下湖',
  room_underground_lake_desc: '心理+30%, 聽覺+25%',
  room_rail_tunnel: '礦車隧道',
  room_rail_tunnel_desc: '物理+30%, 心理+20%',
  room_throne_room: '王座廳',
  room_throne_room_desc: '視覺+25%, 心理+30%',
  room_wine_cellar: '酒窖',
  room_wine_cellar_desc: '心理+30%, 視覺+15%',
  room_tower_chamber: '塔樓房間',
  room_tower_chamber_desc: '心理+35%, 物理+20%',
  room_server_room: '伺服器室',
  room_server_room_desc: '聽覺+30%, 視覺+20%',
  room_quarantine_zone: '隔離區',
  room_quarantine_zone_desc: '心理+35%, 物理+20%',
  room_armory: '軍械庫',
  room_armory_desc: '物理+35%, 視覺+20%',
  room_witch_hut: '女巫小屋',
  room_witch_hut_desc: '視覺+30%, 心理+25%',
  room_treehouse: '樹屋',
  room_treehouse_desc: '物理+25%, 聽覺+20%',
  room_swamp_path: '沼澤小徑',
  room_swamp_path_desc: '心理+30%, 聽覺+20%',
  room_fairy_ring: '仙女環',
  room_fairy_ring_desc: '心理+40%, 視覺+20%',
  room_ancient_ruin: '古代遺跡',
  room_ancient_ruin_desc: '心理+35%, 視覺+25%',
  room_attic: '閣樓',
  room_attic_desc: '心理+30%, 聽覺+15%',
  room_secret_passage: '密道',
  room_secret_passage_desc: '心理+35%, 物理+15%',
  room_morgue: '停屍間',
  room_morgue_desc: '視覺+30%, 心理+30%',
  room_surgery_room: '手術室',
  room_surgery_room_desc: '物理+35%, 視覺+25%',
  room_music_room: '音樂室',
  room_music_room_desc: '聽覺+40%, 心理+20%',
  room_science_lab: '科學實驗室',
  room_science_lab_desc: '視覺+30%, 物理+25%',
  room_ticket_booth: '售票亭',
  room_ticket_booth_desc: '心理+25%, 視覺+20%',
  room_animal_cage: '動物籠',
  room_animal_cage_desc: '物理+30%, 視覺+25%',
  room_clown_tent: '小丑帳篷',
  room_clown_tent_desc: '心理+40%, 視覺+20%',
  room_hall_of_mirrors: '鏡廳',
  room_hall_of_mirrors_desc: '視覺+40%, 心理+30%',
  room_elevator_shaft: '升降機井道',
  room_elevator_shaft_desc: '物理+35%, 心理+20%',
  room_ore_processing: '礦石處理場',
  room_ore_processing_desc: '聽覺+30%, 物理+20%',
  room_collapsed_tunnel: '坍塌隧道',
  room_collapsed_tunnel_desc: '物理+40%, 心理+25%',
  room_miners_quarters: '礦工宿舍',
  room_miners_quarters_desc: '心理+30%, 視覺+20%',
  room_command_center: '指揮中心',
  room_command_center_desc: '心理+30%, 聽覺+25%',
  room_ventilation_shaft: '通風管道',
  room_ventilation_shaft_desc: '物理+35%, 聽覺+25%',
  room_decontamination: '除污室',
  room_decontamination_desc: '心理+35%, 視覺+25%',
  room_hollow_tree: '空心古樹',
  room_hollow_tree_desc: '視覺+30%, 心理+25%',
  room_spider_nest: '蜘蛛巢穴',
  room_spider_nest_desc: '視覺+35%, 物理+25%',
  room_moonlit_clearing: '月光空地',
  room_moonlit_clearing_desc: '心理+40%, 聽覺+20%',
  room_abandoned_cabin: '廢棄小屋',
  room_abandoned_cabin_desc: '心理+30%, 視覺+20%',

  room_ward_room: '病房',
  room_ward_room_desc: '心理+30%, 視覺+20%',
  room_reception_hall: '接待大廳',
  room_reception_hall_desc: '心理+25%, 聽覺+20%',
  room_x_ray_room: 'X光室',
  room_x_ray_room_desc: '視覺+35%, 物理+20%',
  room_classroom: '教室',
  room_classroom_desc: '心理+30%, 聽覺+15%',
  room_art_room: '美術室',
  room_art_room_desc: '視覺+35%, 心理+20%',
  room_gymnasium: '體育館',
  room_gymnasium_desc: '物理+30%, 聽覺+25%',
  room_rooftop: '屋頂',
  room_rooftop_desc: '心理+40%, 物理+20%',
  room_crypt: '地下墓穴',
  room_crypt_desc: '視覺+35%, 心理+25%',
  room_powder_room: '火藥庫',
  room_powder_room_desc: '物理+40%, 聽覺+20%',
  room_navigation_room: '航海室',
  room_navigation_room_desc: '心理+30%, 視覺+20%',
  room_banquet_hall: '宴會廳',
  room_banquet_hall_desc: '心理+30%, 視覺+20%',
  room_chapel: '禮拜堂',
  room_chapel_desc: '心理+40%, 聽覺+20%',
  room_torture_chamber: '拷問室',
  room_torture_chamber_desc: '物理+40%, 視覺+30%',
  room_armory_hall: '武器展示廳',
  room_armory_hall_desc: '物理+30%, 視覺+25%',
  room_science_room: '研究室',
  room_science_room_desc: '視覺+30%, 心理+20%',

  unlock_requires_day: '第{n}天以上',
  unlock_requires_fame: '名聲{n}+',
  unlock_requires_room: '需要: {name}',
  unlock_condition_not_met: '條件未達成',
  room_repair_needed: '需要修理',
  room_repairing: '修理中',
  room_cleaning: '清潔中',
  ghost_roster: '鬼魂名單',
  ghost_idle: '待機中',
  ghost_assigned: '已指派',
  ghost_fatigue: '疲勞值',
  ghost_level: 'Lv.{n}',
  ghost_exp: '經驗值 {cur}/{max}',
  ghost_level_up: '等級提升',
  recover_fatigue: '恢復疲勞 ({sp} SP)',
  ghost_fatigued_warning: '精疲力竭！效率 -50%',
  unassign_ghost: '取消指派',
  ghost_training_in_progress: '訓練中...',
  shop_ghosts: '雇用鬼魂',
  shop_rooms: '房間類型',
  hire: '雇用',
  hire_cost: '{sp} SP',
  already_hired: '已雇用',
  not_enough_sp: 'SP不足！',
  unlock_room_type: '解鎖',
  unlock_cost: '{sp} SP',
  already_unlocked: '已解鎖',
  grade_c: 'C等級',
  grade_b: 'B等級',
  grade_a: 'A等級',
  grade_s: 'S等級',
  ghost_jinaeryeong: '女鬼',
  ghost_gangsi: '殭屍',
  ghost_vampire: '吸血鬼',
  ghost_kappa: '河童',
  ghost_pierrot: '小丑',
  ghost_banshee: '女妖',
  ghost_origin_korea: '韓國',
  ghost_origin_china: '中國',
  ghost_origin_romania: '羅馬尼亞',
  ghost_origin_japan: '日本',
  ghost_origin_usa: '美國',
  ghost_origin_ireland: '愛爾蘭',
  ghost_jinaeryeong_skill: '長髮落下：從天花板落下增加物理恐懼',
  ghost_gangsi_skill: '僵硬跳躍：以僵硬姿勢躍起，同時嚇到2名訪客',
  ghost_vampire_skill: '催眠之眼：凍結1名訪客10秒，下個房間+30%',
  ghost_kappa_skill: '碟子旋轉：旋轉頭頂碟子製造視覺恐懼',
  ghost_pierrot_skill: '笑聲攻擊：突然現身，小丑恐懼',
  ghost_banshee_skill: '尖叫：聽覺恐懼最強，可連續觸發',
  ghost_jinaeryeong_quote: '今天嚇到10名訪客，老闆！',
  ghost_gangsi_quote: '跳來跳去真的很累...',
  ghost_vampire_quote: '夜晚漫長，而我永恆。',
  ghost_kappa_quote: '別把水灑出來！',
  ghost_pierrot_quote: '為何如此嚴肅？',
  ghost_banshee_quote: '叫太多了，喉嚨好痛。',
  ghost_jinaeryeong_fatigued: '老闆...頭髮亂了，我需要休息！',
  ghost_gangsi_fatigued: '我真的動不了了...字面上的。',
  ghost_vampire_fatigued: '就算不死也需要休息...',
  ghost_kappa_fatigued: '碟子乾了，需要水！',
  ghost_pierrot_fatigued: '我笑不出來了，老闆。',
  ghost_banshee_fatigued: '聲音消失了！我無法尖叫！',
  room_unlock_in_shop: '在商店中解鎖',
  visitor_scaredy_kid: '膽小孩子',
  visitor_scaredy_kid_desc: '容易害怕但少許恐懼就能滿足',
  visitor_normal: '一般訪客',
  visitor_normal_desc: '一般恐懼耐受度',
  visitor_brave: '勇敢者',
  visitor_brave_desc: '高耐受度，滿意時大獎勵',
  visitor_couple: '情侶',
  visitor_couple_desc: '適度恐懼，高獎勵，好評論',
  visitor_youtuber: 'YouTuber',
  visitor_youtuber_desc: '評論影響力2.5倍',
  visitor_exorcist: '驅魔師',
  visitor_exorcist_desc: '幾乎無法嚇到，巨大獎勵',
  visitor_thrill_seeker: '尋求刺激者',
  visitor_thrill_seeker_desc: '想要強烈恐懼，對弱者不滿',
  visitor_coward: '膽小鬼',
  visitor_coward_desc: '對一切害怕，容易逃跑',
  time_phase_day: '白天',
  time_phase_evening: '傍晚',
  time_phase_night: '夜晚',
  time_phase_rain: '下雨',
  reputation_label: '聲望: {n}',
  scare_chain: '連鎖 x{n}！',
  terror_max: '恐懼極限！',
  sp_earned: '+{sp} SP',
  prestige_title: '特許經營擴張',
  prestige_desc: '您的鬼屋舉世聞名！要開設加盟店嗎？',
  prestige_requirement_floors: '需要 {n} 層以上',
  prestige_requirement_fame: '需要聲望 {n} 以上',
  prestige_requirement_sp: '需要總獲得SP {n} 以上',
  prestige_not_ready: '條件未達成',
  prestige_confirm: '開設加盟店',
  prestige_level: '威望 Lv.{n}',
  prestige_bonus: '所有鬼魂恐懼 +{n}%，起始SP +{sp}',
  offline_collect: '收取',

  training_title: '演技課程',
  training_select: '選擇訓練',
  training_cost: '{sp} SP',
  training_duration: '{sec}秒',
  training_in_progress: '訓練中...',
  training_complete: '訓練完成！',
  training_bonus: '恐懼力 +{pct}%',
  training_skip_ad: '跳過（廣告）',
  training_count: '{n}次完成',
  training_ghost_busy: '請先取消指派',
  training_already: '正在訓練中',

  training_scream_practice: '尖叫練習',
  training_scream_practice_desc: '改善聲音投射和時機',
  training_jumpscare_acting: '跳嚇演技',
  training_jumpscare_acting_desc: '掌握突然出現的藝術',
  training_psychological_acting: '心理恐懼演技',
  training_psychological_acting_desc: '學習創造持續的不安感',
  training_atmosphere_directing: '氣氛營造',
  training_atmosphere_directing_desc: '控制燈光、聲音和霧氣效果',
  training_physical_training: '體能訓練',
  training_physical_training_desc: '為充滿能量的恐懼鍛煉體力',
  training_audience_analysis: '觀眾分析',
  training_audience_analysis_desc: '研究訪客行為以達到最佳恐懼效果',

  tq_jinaeryeong_scream: '女鬼在YouTube上分析恐怖電影演技...',
  tq_gangsi_scream: '殭屍以僵硬姿勢練習尖叫...',
  tq_vampire_scream: '吸血鬼在地下室哼著歌劇...',
  tq_kappa_scream: '河童在桶裡練習水下尖叫...',
  tq_pierrot_scream: '小丑對著氣球尖叫練習...',
  tq_banshee_scream: '女妖為初學者開設大師課...',
  tq_jinaeryeong_jumpscare: '女鬼反覆從衣櫃裡跳出來...',
  tq_gangsi_jumpscare: '殭屍在跳躍練習前做拉伸...',
  tq_vampire_jumpscare: '吸血鬼練習戲劇性的披風展示...',
  tq_kappa_jumpscare: '河童從馬桶裡彈出來練習...',
  tq_pierrot_jumpscare: '小丑排練氣球爆破的時機...',
  tq_banshee_jumpscare: '女妖練習登場編舞...',
  tq_jinaeryeong_psych: '女鬼在讀心理學教科書...',
  tq_gangsi_psych: '殭屍試著看起來更可怕（本來就是）...',
  tq_vampire_psych: '吸血鬼在鏡子前練習表情...（鏡子裡什麼都沒有）',
  tq_kappa_psych: '河童從圖書館的書中學習人類的恐懼...',
  tq_pierrot_psych: '小丑第50次觀看「牠」...',
  tq_banshee_psych: '女妖撰寫令人毛骨悚然的耳語劇本...',
  tq_jinaeryeong_atmo: '女鬼為最大恐怖效果整理頭髮...',
  tq_gangsi_atmo: '殭屍調整霧氣機的設定...',
  tq_vampire_atmo: '吸血鬼選擇完美的燭光角度...',
  tq_kappa_atmo: '河童測試不同的水滴聲...',
  tq_pierrot_atmo: '小丑用夜光漆塗牆...',
  tq_banshee_atmo: '女妖校準走廊的迴聲效果...',
  tq_jinaeryeong_physical: '女鬼在做天花板爬行運動...',
  tq_gangsi_physical: '殭屍用僵硬的腿做深蹲...',
  tq_vampire_physical: '吸血鬼在棺材裡做伏地挺身...',
  tq_kappa_physical: '河童在池塘裡游泳...',
  tq_pierrot_physical: '小丑邊做仰臥起坐邊雜耍...',
  tq_banshee_physical: '女妖在做聲帶暖身...',
  tq_jinaeryeong_audience: '女鬼在閱讀線上訪客評論...',
  tq_gangsi_audience: '殭屍研究訪客動線模式...',
  tq_vampire_audience: '吸血鬼分析恐懼人口統計...',
  tq_kappa_audience: '河童調查哪個年齡層怕水...',
  tq_pierrot_audience: '小丑追蹤小丑恐懼症統計...',
  tq_banshee_audience: '女妖研究聲波頻率的恐懼反應...',

  props_title: '房間裝飾品',
  prop_buy: '購買 ({sp} SP)',
  prop_upgrade: '升級 ({sp} SP)',
  prop_max: '最高',
  prop_level: 'Lv.{n}',
  prop_bonus: '+{pct}% 恐懼',
  prop_cobwebs: '蜘蛛網',
  prop_cobwebs_desc: '經典陰森氣氛',
  prop_candles: '閃爍蠟燭',
  prop_candles_desc: '詭異的舞動影子',
  prop_blood_pool: '血池',
  prop_blood_pool_desc: '恐怖的地板裝飾',
  prop_skull_decor: '骷髏裝飾',
  prop_skull_decor_desc: '令人毛骨悚然的展示',
  prop_fog_machine: '霧氣機',
  prop_fog_machine_desc: '濃厚神秘的霧',
  prop_creaky_floor: '嘎吱作響的地板',
  prop_creaky_floor_desc: '每一步都會發出聲音',
  prop_eerie_painting: '詭異畫作',
  prop_eerie_painting_desc: '跟隨你的目光',
  prop_chains: '哐啷作響的鎖鏈',
  prop_chains_desc: '令人不安的金屬聲',

  // Staging Equipment
  prop_dry_ice: '乾��機',
  prop_dry_ice_desc: '在地面製造濃霧營造恐怖氛圍',
  prop_scent_sprayer: '氣味噴霧器',
  prop_scent_sprayer_desc: '釋放令人不安的氣味增強恐怖沉浸感',
  prop_strobe_light: '頻閃燈',
  prop_strobe_light_desc: '閃爍的光線擾亂訪客感官',
  prop_surround_speaker: '環繞音響',
  prop_surround_speaker_desc: '空間音效打造令人毛骨悚然的音效',
  prop_vibration_floor: '振動地板',
  prop_vibration_floor_desc: '腳下突然出現震動',
  prop_temp_controller: '溫度控制器',
  prop_temp_controller_desc: '突如其來的冷風帶來心理恐懼',
  prop_hologram_device: '全息投影裝置',
  prop_hologram_device_desc: '在房間中投射幽靈幻影',
  prop_auto_lock: '自動門鎖',
  prop_auto_lock_desc: '門在訪客身後突然鎖上',
  props_category_decoration: '裝飾道具',
  props_category_staging: '演出設備',
  props_staging_desc: '專業恐怖演出的高級設備',

  facilities_title: '附屬設施',
  facility_build: '建造 ({sp} SP)',
  facility_upgrade: '升級 ({sp} SP)',
  facility_level: 'Lv.{n}',
  facility_built: '已建造',
  facility_haunted_house: '鬼屋',
  facility_haunted_house_desc: '恐怖體驗主建築',
  facility_haunted_house_bonus: '主建築入口',
  facility_enter: '進入',

  facility_ticket_booth: '售票處',
  facility_ticket_booth_desc: '向遊客販售門票',
  facility_ticket_booth_bonus: '增加最大遊客容量',
  facility_ticket_booth_visitors: '位遊客',

  facility_gift_shop: '紀念品商店',
  facility_gift_shop_desc: '販售鬼屋紀念品',
  facility_gift_shop_bonus: '每組訪客 +{sp} SP',
  facility_snack_bar: '小吃部',
  facility_snack_bar_desc: '詭異的零食和飲料',
  facility_snack_bar_bonus: '訪客獎勵 +{pct}%',
  facility_photo_booth: '拍照亭',
  facility_photo_booth_desc: '恐懼自拍站',
  facility_photo_booth_bonus: '每組訪客 +{sp} SP',

  reviews_title: '訪客評論',
  reviews_empty: '還沒有評論。等待訪客！',
  reviews_fame_bonus: '+{n} 聲望',
  review_stars: '{n}顆星',
  reviews_avg: '平均：{n}顆星',
  review_5_1: '真的好可怕！尤其是3樓的{ghost}太厲害了！',
  review_5_2: '史上最棒的鬼屋！叫到聲音都沒了！',
  review_5_3: '{ghost}的演技堪比奧斯卡！滿分！',
  review_5_4: '靈魂差點飛走了。物超所值！',
  review_4_1: '{ghost}還蠻可怕的，但上面幾層期待更多。',
  review_4_2: '氣氛超好！差一點就尿褲子了。差一點。',
  review_4_3: '{ghost}令人印象深刻但時機可以更好。',
  review_4_4: '全程驚嚇不斷。會推薦給朋友！',
  review_3_1: '還好。有些空房間破壞了氣氛。',
  review_3_2: '{ghost}今天看起來很累。休息一下？',
  review_3_3: '一般的體驗。需要更多裝飾。',
  review_2_1: '{ghost}工作時在睡覺。請退款。',
  review_2_2: '好笑多過可怕。鬼魂需要演技課程。',
  review_2_3: '{ghost}盡力了但...完全不可怕。',
  review_1_1: '到處都是空房間。這裡有在營業嗎？',
  review_1_2: '我要退錢。我奶奶比這可怕。',
  review_1_3: '{ghost}向我揮手。揮手。這不是嚇人的方式。',

  review_street_5star: '整個主題公園太棒了！鬼屋超恐怖，設施也很好！',
  review_street_4star: '整體體驗不錯。鬼屋很嚇人，點心也好吃。',
  review_street_3star: '還行。鬼屋如果多幾個鬼就好了。',
  review_street_2star: '沒什麼好玩的。鬼屋也一般。',
  review_street_1star: '浪費時間。不恐怖也沒什麼設施。',

  review_vip_satisfied: 'VIP: Perfect! I will definitely come back with my friends.',
  review_vip_unsatisfied: 'VIP: Very disappointing experience. Not worth my time.',

  season_halloween: 'Halloween',
  season_summer_fest: 'Summer Fest',
  season_winter_chill: 'Winter Chill',
  season_spring_bloom: 'Spring Bloom',

  ad_sp_boost: 'SP 2倍增強（30秒）',
  ad_sp_boost_desc: '30秒內所有SP收入翻倍',
  ad_recover_fatigue: '免費恢復',
  ad_recover_fatigue_desc: '免費即時恢復鬼魂疲勞',
  ad_vip_visitor: 'VIP訪客',
  ad_vip_visitor_desc: '召喚高獎勵VIP訪客組',
  ad_skip_training: '跳過訓練',
  ad_skip_training_desc: '立即完成訓練',
  ad_active_boost: '2倍SP生效中！',
  ad_rewards_title: '廣告獎勵',

  // === Business / Open-Close System ===
  day_label: '第 {n} 天',
  hud_operation_day: '營運第{n}天',
  status_open: '营业中',
  status_closed: '已打烊',
  manage_business: 'Manage Business',
  toggle_open: '开始营业',
  toggle_close: '停止营业',
  facility_open_badge: '营业中',
  need_ghost_to_open: '請先將鬼魂分配到房間！',
  ticket_price: '门票价格',
  ticket_price_label: '{n} SP',
  ticket_price_low: '访客多，每人收益少',
  ticket_price_high: '访客少，每人收益多',
  end_day: '结束今天',
  day_summary_title: 'DAY {n} 总结',
  day_summary_visitors: '访客: {n}',
  day_summary_earnings: '收益: {n} SP',
  day_summary_avg_rating: '平均评分: {n}',
  day_summary_next: '结束并领取奖励',
  day_summary_best_visitor: '{n}星访问!',
  day_summary_sp_collected: '总SP收集',
  day_summary_sp_gain: '+{n}',
  day_summary_milestones: '每日目标',
  day_summary_total_visits: '总访问',
  day_summary_reaction_5: '恐怖至极!',
  day_summary_reaction_4: '很可怕!',
  day_summary_reaction_3: '还不错',
  day_summary_reaction_2: '一般...',
  day_summary_reaction_1: '无聊...',

  milestone_visitors_5: '迎接{target}位访客',
  milestone_visitors_10: '迎接{target}位访客',
  milestone_visitors_20: '迎接{target}位访客',
  milestone_earnings_1000: '赚取{target} SP',
  milestone_earnings_5000: '赚取{target} SP',
  milestone_earnings_10000: '赚取{target} SP',
  milestone_flee_0: '零逃跑访客',
  milestone_flee_1: '逃跑访客不超过{target}人',
  milestone_rooms_3: '运营{target}个以上房间',
  milestone_rooms_5: '运营{target}个以上房间',
  milestone_ghosts_2: '部署{target}个以上鬼魂',
  milestone_ghosts_3: '部署{target}个以上鬼魂',
  milestone_reward: '+{n} SP',

  reviews_panel_title: '访客评价',
  reviews_panel_avg: '平均评分',
  reviews_panel_empty: '暂无评价',

  // --- Missing keys (English fallback) ---
  ghost_mummy: 'Mummy',
  ghost_werewolf: 'Werewolf',
  ghost_origin_egypt: 'Egypt',
  ghost_origin_europe: 'Europe',
  ghost_mummy_skill: 'Bandage Wrap: Entangles visitors, physical + visual scare',
  ghost_werewolf_skill: 'Full Moon Howl: Terrifying transformation, max physical + auditory',
  ghost_mummy_quote: 'These bandages are so itchy...',
  ghost_werewolf_quote: 'Is there a full moon tonight? I feel... different.',
  ghost_mummy_fatigued: 'My bandages came undone... I tripped...',
  ghost_werewolf_fatigued: 'Even wolves need sleep... woof... zzz...',
  tq_mummy_scream: 'Mummy practicing muffled screams through bandages...',
  tq_werewolf_scream: 'Werewolf howling at a picture of the moon...',
  tq_mummy_jumpscare: 'Mummy bursting out of sarcophagus repeatedly...',
  tq_werewolf_jumpscare: 'Werewolf practicing surprise transformations...',
  tq_mummy_psych: 'Mummy reading ancient curse scrolls for inspiration...',
  tq_werewolf_psych: 'Werewolf studying pack hunting psychology...',
  tq_mummy_atmo: 'Mummy arranging ancient Egyptian artifacts for ambiance...',
  tq_werewolf_atmo: 'Werewolf setting up moonlight projectors...',
  tq_mummy_physical: 'Mummy doing stretches to prevent bandage tangles...',
  tq_werewolf_physical: 'Werewolf doing 500 push-ups in wolf form...',
  tq_mummy_audience: 'Mummy researching which civilization visitors fear most...',
  tq_werewolf_audience: 'Werewolf tracking which visitors have dog allergies...',

  view_building: '建築',
  view_other_buildings: '< 查看其他建築',
  view_lobby: '等候室',
  view_facilities: '附屬設施',
  view_academy: '教育院',
  lobby_title: '等候室',
  lobby_queue: '排隊',
  lobby_queue_empty: '沒有等候的遊客',
  lobby_active_teams: '探險中: {cur}/{max}隊',
  lobby_wait_time: '等候: {n}秒',
  lobby_team_size: '{n}位遊客',
  lobby_staff: '大廳員工',
  lobby_staff_empty: '未分配員工',
  lobby_assign_staff: '分配員工',
  lobby_unassign_staff: '解除',
  lobby_staff_effect: '縮短等候時間，提高遊客滿意度',
  lobby_ticket_booth: '售票處',
  facilities_view_title: '設施管理',
  facilities_view_empty: '尚未建造設施。請在選單中建造!',
  facility_staff: '員工',
  facility_staff_none: '無員工',
  facility_assign_staff: '分配員工',
  facility_unassign_staff: '解除員工',
  facility_staff_bonus: '員工可提升服務品質',
  facility_restroom: '洗手間',
  facility_restroom_desc: '防止滿意度懲罰',
  facility_restroom_bonus: '建造後無懲罰',
  facility_parking_lot: '停車場',
  facility_parking_lot_desc: '增加遊客到達率',
  facility_parking_lot_bonus: '每級遊客率+{pct}%',
  facility_first_aid: '急救站',
  facility_first_aid_desc: '照護逃跑/暈倒的遊客',
  facility_first_aid_bonus: '防止逃跑造成差評',
  facility_arcade: '遊樂場',
  facility_arcade_desc: '迷你遊戲與恐怖景點',
  facility_arcade_bonus: '增加訪客興奮度',
  facility_fortune_teller: '占卜師',
  facility_fortune_teller_desc: '神秘的塔羅牌與手相',
  facility_fortune_teller_bonus: '提升訪客滿意度',
  facility_escape_room: '密室逃脫',
  facility_escape_room_desc: '限時恐怖解謎挑戰',
  facility_escape_room_bonus: '每位訪客高收益',
  facility_stage: '舞台',
  facility_stage_desc: '鬼魂表演秀',
  facility_stage_bonus: '提升全園名聲',
  facility_voodoo_shop: '巫毒商店',
  facility_voodoo_shop_desc: '詛咒護身符與魔法道具',
  facility_voodoo_shop_bonus: '提升特殊物品掉落率',
  facility_ghost_cafe: '幽靈咖啡廳',
  facility_ghost_cafe_desc: '鬼魂調製的神秘飲品',
  facility_ghost_cafe_bonus: '延長訪客停留時間',
  facility_phantom_cinema: '幻影電影院',
  facility_phantom_cinema_desc: '超自然恐怖電影放映',
  facility_phantom_cinema_bonus: '高票房收益',
  facility_skeleton_spa: '骷髏溫泉',
  facility_skeleton_spa_desc: '放鬆到骨子裡的溫泉',
  facility_skeleton_spa_bonus: '加速鬼魂疲勞恢復',
  academy_title: '鬼魂教育院',
  academy_empty: '請先雇用鬼魂再開始訓練!',
  academy_select_ghost: '選擇要訓練的鬼魂',
  academy_select_training: '選擇教育課程',
  academy_skill_level: 'Lv.{n}/{max}',
  academy_skill_maxed: '已精通',
  academy_training_time: '{sec}秒',
  academy_training_cost: '{sp} SP',
  academy_in_progress: '訓練中...',
  academy_complete: '完成!',
  academy_skip_ad: '跳過(廣告)',
  academy_ghost_busy: '鬼魂正忙',
  academy_acting: '演技課',
  academy_acting_desc: '提升恐嚇表演和時機',
  academy_acting_effect: '每級恐懼效果+20%',
  academy_human_relations: '人際關係',
  academy_human_relations_desc: '學習理解遊客',
  academy_human_relations_effect: '每級滿意度+15%',
  academy_psychology: '心理學',
  academy_psychology_desc: '針對遊客弱點',
  academy_psychology_effect: '每級弱點打擊加成',
  academy_special_fx: '特效實習',
  academy_special_fx_desc: '精通道具和效果使用',
  academy_special_fx_effect: '每級道具加成x2',
  academy_fitness: '體能訓練',
  academy_fitness_desc: '提升體力和耐力',
  academy_fitness_effect: '每級疲勞恢復+50%',
  academy_teamwork: '團隊合作',
  academy_teamwork_desc: '與相鄰鬼魂協調',
  academy_teamwork_effect: '每級連鎖恐嚇+30%',
  academy_customer_service: '客戶服務',
  academy_customer_service_desc: '提升大廳/設施服務',
  academy_customer_service_effect: '每級服務品質提升',
  facility_detail_income: '收入',
  facility_detail_sp_per_group: '每組 {n} SP',
  facility_detail_bonus: '獎勵',
  facility_detail_upgrade: '升級 ({sp} SP)',
  facility_detail_assign: '配置員工',
  facility_detail_status_active: '營運中',
  facility_detail_status_buildable: '可建設',
  facility_detail_status_locked: '已鎖定',
  facility_detail_no_income: '無直接收入',
  ghost_role_scare: '恐嚇擔當',
  ghost_role_lobby_staff: '大廳員工',
  ghost_role_facility_staff: '設施員工',
  ghost_role_instructor: '教官',
  shop_pro_ghosts: 'Professional Ghosts',
  pro_ghost_badge: 'PRO',
  ghost_grim_reaper: 'Grim Reaper',
  ghost_origin_underworld: 'Underworld',
  ghost_grim_reaper_skill: 'Soul Harvest: All fear types S-rank, absolute terror',
  ghost_grim_reaper_quote: 'Your time has come... just kidding. Or am I?',
  ghost_grim_reaper_fatigued: 'Even death needs a vacation sometimes...',
  ghost_grim_reaper_unique: 'Instant max fear on any visitor type',
  ghost_blood_count: 'Blood Count',
  ghost_origin_transylvania: 'Transylvania',
  ghost_blood_count_skill: 'Blood Charm: Charisma-based visual + psychological S-rank',
  ghost_blood_count_quote: 'I do not drink... wine.',
  ghost_blood_count_fatigued: 'The sun... it burns... need coffin...',
  ghost_blood_count_unique: 'Charm aura: adjacent rooms get +20% scare',
  ghost_well_spirit: 'Well Spirit',
  ghost_well_spirit_skill: 'Well Crawl: Psychological horror S-rank, lingering dread',
  ghost_well_spirit_quote: '...seven days...',
  ghost_well_spirit_fatigued: 'My hair is so tangled... need conditioner...',
  ghost_well_spirit_unique: 'Lingering fear: visitors stay scared in next room',
  ghost_nightmare_specter: 'Nightmare Specter',
  ghost_origin_dreamworld: 'Dream World',
  ghost_nightmare_specter_skill: 'Nightmare Slash: Physical + psychological S-rank dream terror',
  ghost_nightmare_specter_quote: 'Sweet dreams... or not.',
  ghost_nightmare_specter_fatigued: 'Even nightmares need beauty sleep...',
  ghost_nightmare_specter_unique: 'Dream invasion: double scare on sleeping visitors',
  ghost_shadow_stalker: 'Shadow Stalker',
  ghost_origin_void: 'The Void',
  ghost_shadow_stalker_skill: 'Static Presence: Psychological horror max, stalker-type',
  ghost_shadow_stalker_quote: '...',
  ghost_shadow_stalker_fatigued: '......',
  ghost_shadow_stalker_unique: 'Static aura: all visitors on floor get +15% fear',

  // === Visitor Reactions ===
  reaction_angry: '#!',
  reaction_excited: '*',

  lobby_room_ticket_booth: '售票處',
  lobby_room_ticket_booth_desc: '遊客購買門票的地方',
  lobby_room_ticket_booth_effect: '基本售票處理速度',
  lobby_room_waiting_lounge: '等候大廳',
  lobby_room_waiting_lounge_desc: '附設座位的舒適等候區',
  lobby_room_waiting_lounge_effect: '每級遊客耐心+20%',
  lobby_room_vip_lounge: 'VIP貴賓室',
  lobby_room_vip_lounge_desc: 'VIP遊客專用高級等候室',
  lobby_room_vip_lounge_effect: 'VIP遊客消費2倍SP',
  lobby_room_reservation_center: '預約中心',
  lobby_room_reservation_center_desc: '遊客預約系統',
  lobby_room_reservation_center_effect: '每級遊客出現率+15%',

  lobby_build_floor: '+ {name} ({sp} SP)',
  lobby_build_select: '選擇要建造的設施...',
  lobby_add_floor: '+ {sp} SP',
  lobby_empty_floor: '建造設施',
  lobby_select_facility: '選擇設施',
  lobby_props_count: '{n} 道具',
  lobby_props_title: '物件',
  lobby_tab_info: '資訊',
  lobby_tab_objects: '物件',
  lobby_tab_upgrade: '升級',
  lobby_tab_demolish: '拆除',
  lobby_demolish_confirm: '確定要拆除此設施嗎？樓層會保留，變成空樓層。',
  lobby_demolish_btn: '拆除設施',
  lobby_no_ghost: '無員工',
  lobby_upgrade_max: '已達最高等級',
  lobby_upgrade_next: 'Lv.{from} -> Lv.{to}',
  lobby_upgrade_effect: '升級後效果：',
  facility_build_floor: '建造',

  facility_map_title: '設施區域',
  facility_build_here: '建造',
  facility_select_to_build: '選擇設施',
  facility_all_built: '所有設施已建造完成。',
  facility_unlock_plot: '{sp} SP',
  facility_unlock_plot_title: '解鎖區塊',
  facility_unlock_plot_desc: '花費 {sp} SP 解鎖此區塊以建造新設施。',
  facility_unlock_plot_btn: '解鎖 ({sp} SP)',
  facility_build_popup_title: '建造設施',
  facility_build_action: '建造',
  facility_select_theme: '選擇主題',
  facility_upgrade_preview: '升級效果',
  facility_upgrade_revenue: '每組收益',
  facility_upgrade_bonus: '收益加成',
  facility_upgrade_capacity: '容量',
  facility_upgrade_current: '目前',
  facility_upgrade_next: '下一級',
  facility_upgrade_max_level: '已達最高等級',
  facility_revenue: '營收',
  facility_total_revenue: '總營收',
  facility_hourly_revenue: '每組',
  facility_set_price: '設定價格',
  facility_price_hint_high: '高價格：利潤增加，遊客減少',
  facility_price_hint_low: '低價格：遊客增加，利潤減少',
  facility_price_hint_free: '免費入場',
  facility_price_hint_normal: '價格適中',
  facility_open: '開業',
  facility_close: '停業',
  facility_closed_badge: '停業中',
  facility_needs_staff: '派駐員工後才能開業',
  facility_demolish: '拆除',
  facility_demolish_confirm: '拆除 {name}？此操作無法復原。',
  facility_move: '移動',
  facility_move_select: '選擇空白區塊移動',
  facility_move_no_empty: '沒有可用的空白區塊。',

  lobby_prop_sofa: '沙發',
  lobby_prop_sofa_desc: '等候遊客的舒適座椅',
  lobby_prop_tv_screen: '電視螢幕',
  lobby_prop_tv_screen_desc: '等候時的娛樂',
  lobby_prop_vending_machine: '自動販賣機',
  lobby_prop_vending_machine_desc: '遊客的零食和飲料',
  lobby_prop_info_sign: '指示牌',
  lobby_prop_info_sign_desc: '引導遊客到正確的地方',
  lobby_prop_potted_plant: '盆栽',
  lobby_prop_potted_plant_desc: '增添陰森的綠意',
  lobby_prop_umbrella_stand: '傘架',
  lobby_prop_umbrella_stand_desc: '放置濕傘的地方',

  fac_prop_display_shelf: '展示架',
  fac_prop_display_shelf_desc: '吸引地展示商品',
  fac_prop_cash_register: '收銀機',
  fac_prop_cash_register_desc: '加快交易速度',
  fac_prop_coffee_machine: '咖啡機',
  fac_prop_coffee_machine_desc: '提供熱飲',
  fac_prop_menu_board: '菜單板',
  fac_prop_menu_board_desc: '顯示食物和飲品選項',
  fac_prop_camera_light: '攝影燈',
  fac_prop_camera_light_desc: '更好的拍照照明',
  fac_prop_backdrop: '背景幕',
  fac_prop_backdrop_desc: '主題拍照背景',
  fac_prop_hand_dryer: '烘手機',
  fac_prop_hand_dryer_desc: '保持清潔乾燥',
  fac_prop_mirror: '鏡子',
  fac_prop_mirror_desc: '陰森浴室必備品',
  fac_prop_parking_sign: '停車指示牌',
  fac_prop_parking_sign_desc: '引導遊客到停車場',
  fac_prop_barrier_gate: '閘門',
  fac_prop_barrier_gate_desc: '自動停車管理',
  fac_prop_first_aid_kit: '急救箱',
  fac_prop_first_aid_kit_desc: '基本醫療用品',
  fac_prop_stretcher: '擔架',
  fac_prop_stretcher_desc: '為嚇暈的遊客準備',

  tab_facilities: '設施',
  tab_hire: '招聘',
  tab_staff: '員工',
  tab_support_facilities: '附屬設施',
  tab_achievements: '成就',
  achievements_title: '成就',
  achievements_coming_soon: '即將推出...',
  facilities_mgmt_title: '設施管理',
  facility_condition: '老化度',
  facility_hygiene: '衛生度',
  facility_condition_warning: '需要維修!',
  facility_hygiene_warning: '需要清潔!',
  dispatch_repair: '派遣維修',
  dispatch_clean: '派遣清潔',
  no_repair_staff: '沒有維修員工',
  no_janitor_staff: '沒有清潔員工',
  repair_dispatched: '已派遣維修人員',
  clean_dispatched: '已派遣清潔人員',
  ticket_section_title: '門票價格',
  expected_visitors: '預計遊客: ~{n}人/天',
  star_rating_title: '遊客評價',
  star_level_gray: '灰色星',
  star_level_bronze: '銅星',
  star_level_silver: '銀星',
  star_level_gold: '金星',
  star_level_rainbow: '彩虹星',
  star_evolution_max: '最佳鬼屋',
  star_current: '{cur}/{max}',
  hire_title: '招聘員工',
  hire_scare_section: '驚嚇專家',
  hire_staff_section: '設施員工',
  staff_role_repair: '維修工',
  staff_role_janitor: '清潔工',
  staff_role_ticket: '售票員',
  staff_role_guide: '導遊',
  staff_role_repair_desc: '維修設施老化',
  staff_role_janitor_desc: '管理設施衛生',
  staff_role_ticket_desc: '經營大廳',
  staff_role_guide_desc: '遊客滿意度加成',
  hire_cost_label: '{sp} SP',
  staff_title: '員工列表',
  staff_empty: '尚未僱用員工。',
  staff_detail_title: '員工詳情',
  staff_detail_type: '種類',
  staff_detail_role: '角色',
  staff_detail_grade: '等級',
  staff_detail_skills: '技能',
  staff_detail_assigned: '配置位置',
  staff_detail_not_assigned: '未配置',
  staff_detail_hired_days: '入職: 第{n}天',
  staff_detail_praise: '稱讚: {n}',
  skill_acting: '演技',
  skill_friendliness: '親和力',
  skill_psychology: '心理學',
  skill_special_fx: '特效',
  skill_fitness: '體力',
  skill_teamwork: '團隊合作',
  skill_service: '客戶服務',
  room_detail_tab_info: '房間資訊',
  room_detail_tab_props: '設施',
  room_detail_tab_upgrade: '升級',
  room_detail_tab_demolish: '拆除',
  room_detail_ghost_none: '未配置',
  room_detail_condition: '耐久度',
  room_detail_hygiene: '清潔度',
  room_detail_request_repair: '請求修理 ({sp} SP)',
  room_detail_request_cleaning: '請求清潔 ({sp} SP)',
  room_detail_repairing: '修理中... {sec}秒',
  room_detail_cleaning: '清潔中... {sec}秒',
  room_detail_collapsed: '已崩塌',
  room_detail_collapsed_desc: '房間已崩塌。修理後可恢復。',
  room_detail_condition_ok: '耐久度良好',
  room_detail_hygiene_ok: '清潔度良好',
  room_upgrade_structure: '結構強化',
  room_upgrade_structure_desc: '減少每次訪問的耐久度下降',
  room_upgrade_structure_effect: '每級減少耐久度下降 -{pct}%',
  room_upgrade_structure_bonus_10: '堅固房間：修理費 -30%',
  room_upgrade_structure_bonus_20: '不朽房間：耐久度最低50',
  room_upgrade_purify: '自動淨化',
  room_upgrade_purify_desc: '減少每次訪問的清潔度下降',
  room_upgrade_purify_effect: '每級減少清潔度下降 -{pct}%',
  room_upgrade_purify_bonus_10: '芳香房間：滿意度 +10%',
  room_upgrade_purify_bonus_20: '自動清潔魔法：清潔度自動恢復',
  room_upgrade_level: 'Lv.{cur}/{max}',
  room_upgrade_cost: '升級 ({sp} SP)',
  room_upgrade_max: '最大',
  room_upgrade_bonus_unlocked: '已解鎖!',
  room_upgrade_bonus_locked: 'Lv.{n} 獎勵',
  room_demolish_warning: '拆除此房間將永久刪除所有設施和升級。',
  room_demolish_cost: '費用：免費',
  room_demolish_btn: '拆除房間',
  room_demolish_confirm: '確定要拆除此房間嗎？此操作無法撤銷。',
  room_props_installed: '已安裝道具',
  room_props_available: '可用道具',
  room_props_none: '尚無道具',
  menu_bgm: 'BGM',
  menu_sfx: 'SFX',
  menu_language: '語言',
  menu_reset: '重置遊戲',
  menu_reset_confirm: '確定要重置所有進度嗎？此操作無法撤銷。',
  menu_info: '遊戲資訊',
  menu_version: '版本 {v}',
  menu_on: 'ON',
  menu_off: 'OFF',

  // === Room Emotion Stats ===
  stat_fear: '恐懼度',
  stat_thrill: '刺激',
  stat_atmosphere: '氛圍',
  stat_fun: '趣味',
  stat_total: '房間屬性',
  room_grade: '等級',
  grade_S: 'S',
  grade_A: 'A',
  grade_B: 'B',
  grade_C: 'C',
  grade_D: 'D',
  grade_F: 'F',

  phase_day: '\u6E96\u5099',
  phase_evening: '\u71DF\u696D\u4E2D',
  phase_night: '\u6253\u70C8',
  phase_day_icon: '\u2600',
  phase_evening_icon: '\uD83C\uDF19',
  phase_night_icon: '\u2B50',
  phase_remaining: '{sec}\u79D2',
  phase_day_hint: '\u6E96\u5099\u9B3C\u5C4B\uFF01\u4FEE\u7406\u3001\u914D\u7F6E\u9B3C\u602A\u3001\u5347\u7D1A\u3002',
  phase_evening_hint: '\u71DF\u696D\u6642\u9593\uFF01\u904A\u5BA2\u4F86\u4E86\u3002',
  open_now_btn: '\u7ACB\u5373\u958B\u5E97',
  speed_btn: 'x{n}',
  day_auto_open_hint: '\u508D\u665A\u4E86\uFF01\u958B\u59CB\u71DF\u696D\u5427\u3002',
  evening_ending_hint: '\u6253\u70C8\u6642\u9593\uFF01\u6574\u7406\u4E2D...',
  floor1_blocked_warning: '\u7981\u6B62\u5165\u5834\uFF01\u8ACB\u4FEE\u7406\u4E00\u6A13\uFF01',
  gstaff_title: '\u5e7d\u9748\u54e1\u5de5',
  gstaff_repairman: '\u4fee\u7406\u5e7d\u9748',
  gstaff_repairman_desc: '\u7a7f\u904e\u7246\u58c1\u4fee\u7406\u623f\u9593\u7684\u80fd\u5e79\u5e7d\u9748',
  gstaff_repairman_effect: '\u81ea\u52d5\u4fee\u7406\u6700\u4f4e\u8010\u4e45\u5ea6\u623f\u9593',
  gstaff_janitor: '\u6e05\u6f54\u5e7d\u9748',
  gstaff_janitor_desc: '\u7528\u9748\u529b\u6e05\u6f54\u623f\u9593',
  gstaff_janitor_effect: '\u81ea\u52d5\u6e05\u6f54\u6700\u4f4e\u885b\u751f\u5ea6\u623f\u9593',
  gstaff_promoter: '\u5ba3\u50b3\u5e7d\u9748',
  gstaff_promoter_desc: '\u7528\u9670\u68ee\u7684\u8033\u8a9e\u5438\u5f15\u904a\u5ba2',
  gstaff_promoter_effect: '\u6bcf\u7d1a\u904a\u5ba2+20%',
  gstaff_medic: '\u6cbb\u7642\u5e7d\u9748',
  gstaff_medic_desc: '\u7528\u5e7d\u9748\u7684\u9b45\u529b\u5b89\u64ab\u9a5a\u6050\u7684\u904a\u5ba2',
  gstaff_medic_effect: '\u9003\u8dd1\u904a\u5ba2\u7559\u4e0b\u4e2d\u6027\u8a55\u50f9',
  gstaff_security: '\u8b66\u885b\u5e7d\u9748',
  gstaff_security_desc: '\u4ee5\u5a01\u5687\u7684\u5b58\u5728\u611f\u7dad\u6301\u79e9\u5e8f',
  gstaff_security_effect: '\u6bcf\u7d1a\u6eff\u610f\u5ea6+10%',
  gstaff_hire_cost: '\u53ec\u559a: {sp} SP',
  gstaff_salary: '\u7dad\u6301\u8cbb: {sp} SP/\u65e5',
  gstaff_fire: '\u9664\u9748',
  gstaff_fire_confirm: '\u78ba\u5b9a\u8981\u9664\u9748\u9019\u4f4d\u5e7d\u9748\u54e1\u5de5\u55ce\uff1f',
  gstaff_level: 'Lv.{n}',
  gstaff_none: '\u5c1a\u672a\u53ec\u559a\u5e7d\u9748\u54e1\u5de5\u3002',
  day_summary_salaries: '\u54E1\u5DE5\u85AA\u8CC7',
  day_summary_net_earnings: '\u6DE8\u6536\u76CA',
  day_summary_street_visitors: '\u8857\u982D\u904A\u5BA2',
  day_summary_street_revenue: '\u8857\u982D\u6536\u76CA',
  day_summary_reviews_title: '\u904A\u5BA2\u8A55\u50F9',
  day_summary_avg_stars: '\u5E73\u5747\u8A55\u5206',
  day_summary_fame_change: '\u540D\u8072',
  day_summary_no_reviews: '\u4ECA\u5929\u6C92\u6709\u8A55\u50F9',
  day_summary_review_visitor: '\u904A\u5BA2 #{n}',
  day_summary_highlight: '\u4EAE\u9EDE',

  // === Tutorial ===
  tutorial_welcome_title: '\u6B61\u8FCE\u4F86\u5230\u9B3C\u5C4B!',
  tutorial_welcome_body: '\u5F9E\u4ECA\u5929\u958B\u59CB\u4F60\u5C31\u662F\u9B3C\u5C4B\u7684\u4E3B\u4EBA\u4E86\u3002\u548C\u5C0F\u9B3C\u5011\u4E00\u8D77\u6253\u9020\u6700\u6709\u8DA3\u7684\u9B3C\u5C4B\u5427!',
  tutorial_welcome_btn: '\u958B\u59CB\u5427!',
  tutorial_build_title: '\u5EFA\u9020\u623F\u9593',
  tutorial_build_body: '\u9996\u5148\u5EFA\u9020\u4E00\u500B\u623F\u9593\u5427\u3002\u9EDE\u64CA\u300C+\u300D\u6309\u9215\u9078\u64C7\u623F\u9593\u985E\u578B\u3002',
  tutorial_ghost_title: '\u914D\u7F6E\u5C0F\u9B3C',
  tutorial_ghost_body: '\u628A\u5C0F\u9B3C\u5B89\u6392\u5230\u623F\u9593\u88E1\u4F86\u5687\u5687\u5BA2\u4EBA\u5427\u3002\u9EDE\u64CA\u623F\u9593\u4F86\u914D\u7F6E\u5C0F\u9B3C\u3002',
  tutorial_open_title: '\u958B\u9580\u71DF\u696D',
  tutorial_open_body: '\u6E96\u5099\u5B8C\u6210! \u9EDE\u64CA\u4E0B\u65B9\u300C\u958B\u9580\u300D\u6309\u9215\u8FCE\u63A5\u5BA2\u4EBA\u5427\u3002',
  tutorial_facility_intro_title: '\u8A2D\u65BD\u5340\u57DF',
  tutorial_facility_intro_body: '\u4F60\u7684\u6A02\u5712\u6709\u8A2D\u65BD\u5EFA\u8A2D\u5340! \u5EFA\u9020\u5546\u5E97\u548C\u904A\u6A02\u8A2D\u65BD\u4F86\u589E\u52A0\u6536\u5165\u3002',
  tutorial_facility_build_title: '\u5EFA\u9020\u8A2D\u65BD',
  tutorial_facility_build_body: '\u9EDE\u64CA\u7A7A\u5730\u4E26\u9078\u64C7\u8A2D\u65BD\u3002\u63A8\u85A6\u7D00\u5FF5\u54C1\u5E97\u6216\u5C0F\u5403\u5E97!',
  tutorial_facility_staff_title: '\u914D\u7F6E\u54E1\u5DE5',
  tutorial_facility_staff_body: '\u70BA\u65B0\u8A2D\u65BD\u914D\u7F6E\u9B3C\u9B42\u3002\u6709\u54E1\u5DE5\u7684\u8A2D\u65BD\u6536\u5165\u589E\u52A020%!',
  tutorial_facility_open_title: '\u958B\u653E\u8A2D\u65BD',
  tutorial_facility_open_body: '\u958B\u653E\u8A2D\u65BD\u8B93\u904A\u5BA2\u4F7F\u7528\u3002\u4F60\u9084\u53EF\u4EE5\u8A2D\u5B9A\u50F9\u683C!',
  tutorial_done_title: '\u6559\u5B78\u5B8C\u6210!',
  tutorial_done_body: '\u592A\u68D2\u4E86! \u4F60\u5DF2\u7D93\u638C\u63E1\u4E86\u57FA\u672C\u64CD\u4F5C\u3002\u7E7C\u7E8C\u64F4\u5EFA\u4F60\u7684\u9B3C\u5C4B\u5427!',
  tutorial_skip: '\u8DF3\u904E',
  tutorial_next: '\u4E0B\u4E00\u6B65',
  tutorial_got_it: '\u77E5\u9053\u4E86!',

  // === Story Arc System ===
  story_intro: '起',
  story_rising: '承',
  story_climax: '轉',
  story_resolution: '合',
  story_grade: '故事動線: {grade} (+{bonus}% SP)',
  story_bonus: '+{bonus}% SP',
  story_guide_title: '故事動線系統已解鎖!',
  story_guide_desc: '擁有4間以上的房間後，安排起承轉合的動線即可獲得額外SP獎勵!',
  story_role_label: '{role}',
  story_intro_desc: '營造氛圍: 高氣氛、低恐懼',
  story_rising_desc: '緊張升級: 提高恐懼與刺激',
  story_climax_desc: '恐懼巔峰: 恐懼與刺激最大化',
  story_resolution_desc: '釋放與樂趣: 增強趣味',
  story_room_role: '故事角色: {role}',
  story_none: '無',

  // === Room Available Props ===
  room_available_props: '可安裝: {props}',

  // === Lobby Queue System ===
  lq_waiting_count: '等候: {n}/{max}',
  lq_avg_patience: '平均耐心: {n}%',
  lq_queue_empty: '等候區沒有遊客',

  // === Lobby Facilities ===
  lf_title: '大廳設施',
  lf_patience_bonus: '耐心 -{n}%',
  lf_revenue_bonus: '+{n} SP/遊客',
  lf_npc_bonus: 'NPC員工: 耐心+15%、收益+20%',
  lf_npc_staff: 'NPC員工',

  lf_ticket_booth: '售票處',
  lf_ticket_booth_desc: '必備售票櫃台',
  lf_waiting_lounge: '等候休息室',
  lf_waiting_lounge_desc: '舒適的座位等候區 (+耐心)',
  lf_vip_lounge: 'VIP休息室',
  lf_vip_lounge_desc: 'VIP遊客專用高級等候區',
  lf_reservation_center: '預約中心',
  lf_reservation_center_desc: '遊客預約系統 (+耐心)',
  lf_poster_wall: '海報牆',
  lf_poster_wall_desc: '恐怖海報增加期待感（+耐心）',
  lf_snack_cart: '零食車',
  lf_snack_cart_desc: '零食讓遊客保持耐心',
  lf_souvenir_booth: '紀念品攤',
  lf_souvenir_booth_desc: '販售紀念品增加收益',
  lf_photo_zone: '拍照區',
  lf_photo_zone_desc: '遊客拍照提升名聲和收益',
  lf_tv_monitor: '電視螢幕',
  lf_tv_monitor_desc: '恐怖精華影片減少無聊感',
  lf_costume_rental: '服裝租借',
  lf_costume_rental_desc: '出租服裝增加樂趣和收益',
  lf_fortune_booth: '占卜攤',
  lf_fortune_booth_desc: '神秘占卜營造恐怖氛圍',
  lf_built_badge: '已建造',

  // === Lobby Facility Unique Effects ===
  lf_ue_ticket_speed: '售票速度: 每級入場間隔 -15%',
  lf_ue_max_queue_up: '容納人數: 每級最大排隊人數 +5',
  lf_ue_vip_rate_up: 'VIP比率: 每級VIP訪客出現率 x2',
  lf_ue_satisfaction_up: '期待感: 基礎滿意度 +20%',
  lf_ue_emergency_patience: '緊急零食: 低耐心訪客 +15恢復',
  lf_ue_revisit_rate_up: '紀念品: 隔日訪客獎勵 +15%',
  lf_ue_reputation_per_day: 'SNS分享: 每級每日聲望 +2',
  lf_ue_anticipation_up: '恐怖預覽: 期待感 +40%',
  lf_ue_fun_bonus: '服裝: 每級趣味值 +15',
  lf_ue_random_sp_bonus: '占卜: 隨機獎勵SP機率 +10%',
  ticket_price_setting: '門票價格設定',

  // === Lobby Facility Props ===
  lobby_prop_candle: '蠟燭',
  lobby_prop_candle_desc: '營造氛圍的閃爍蠟燭',
  lobby_prop_cobweb: '蜘蛛網',
  lobby_prop_cobweb_desc: '陰森的蜘蛛網裝飾',
  lobby_prop_pumpkin: '南瓜',
  lobby_prop_pumpkin_desc: '經典的南瓜燈籠',
  lobby_prop_magazine_rack: '雜誌架',
  lobby_prop_magazine_rack_desc: '等候時閱讀的恐怖雜誌',
  lobby_prop_chandelier: '水晶吊燈',
  lobby_prop_chandelier_desc: '優雅的哥德式水晶吊燈',
  lobby_prop_wine_glass: '酒杯',
  lobby_prop_wine_glass_desc: 'VIP氛圍的水晶酒杯',
  lobby_prop_velvet_curtain: '天鵝絨窗簾',
  lobby_prop_velvet_curtain_desc: '高級感的天鵝絨布幔',
  lobby_prop_gold_frame: '金框',
  lobby_prop_gold_frame_desc: '華麗的金色畫框',
  lobby_prop_picture_frame: '畫框',
  lobby_prop_picture_frame_desc: '牆上的詛咒肖像',
  lobby_prop_spotlight: '聚光燈',
  lobby_prop_spotlight_desc: '展示用的戲劇性照明',
  lobby_prop_skull_ornament: '骷髏裝飾',
  lobby_prop_skull_ornament_desc: '營造陰森氣氛的裝飾骷髏',
  lobby_prop_pumpkin_cookie: '南瓜餅乾',
  lobby_prop_pumpkin_cookie_desc: '美味的南瓜形餅乾',
  lobby_prop_ghost_drink: '幽靈飲料',
  lobby_prop_ghost_drink_desc: '神秘發光的飲品',
  lobby_prop_napkin_holder: '餐巾架',
  lobby_prop_napkin_holder_desc: '保持零食區整潔',
  lobby_prop_display_shelf: '展示架',
  lobby_prop_display_shelf_desc: '吸引人地展示紀念品',
  lobby_prop_plush_doll: '玩偶',
  lobby_prop_plush_doll_desc: '可愛的幽靈絨毛玩偶',
  lobby_prop_keychain_rack: '鑰匙圈架',
  lobby_prop_keychain_rack_desc: '旋轉式恐怖鑰匙圈展示架',
  lobby_prop_wrapping_paper: '包裝紙',
  lobby_prop_wrapping_paper_desc: '萬聖節主題禮物包裝紙',
  lobby_prop_backdrop: '背景板',
  lobby_prop_backdrop_desc: '主題拍照背景',
  lobby_prop_prop_box: '道具箱',
  lobby_prop_prop_box_desc: '有趣的拍照道具箱',
  lobby_prop_mask_stand: '面具展示架',
  lobby_prop_mask_stand_desc: '拍照用的恐怖面具展示',
  lobby_prop_antenna: '天線',
  lobby_prop_antenna_desc: '電視訊號接收器',
  lobby_prop_remote_control: '遙控器',
  lobby_prop_remote_control_desc: '控制電視頻道',
  lobby_prop_speaker: '喇叭',
  lobby_prop_speaker_desc: '恐怖影片的環繞音效',
  lobby_prop_cable_wires: '電線',
  lobby_prop_cable_wires_desc: '纏繞的電線增添陰森感',
  lobby_prop_clothes_rack: '衣架',
  lobby_prop_clothes_rack_desc: '掛滿恐怖服裝的衣架',
  lobby_prop_mirror: '鏡子',
  lobby_prop_mirror_desc: '檢查服裝的全身鏡',
  lobby_prop_makeup_table: '化妝台',
  lobby_prop_makeup_table_desc: '在這裡化恐怖妝',
  lobby_prop_wig_stand: '假髮架',
  lobby_prop_wig_stand_desc: '恐怖假髮收藏',
  lobby_prop_crystal_ball: '水晶球',
  lobby_prop_crystal_ball_desc: '窺視你的恐怖未來',
  lobby_prop_tarot_cards: '塔羅牌',
  lobby_prop_tarot_cards_desc: '神秘的占卜牌',
  lobby_prop_curtain: '窗簾',
  lobby_prop_curtain_desc: '占卜攤用的神秘窗簾',
  lobby_prop_candelabra: '燭台',
  lobby_prop_candelabra_desc: '營造氛圍的多臂燭台',

  lnpc_title: 'Lobby Ghost Patrol',
  lnpc_assign: 'Assign Ghost',
  lnpc_unassign: 'Remove',
  lnpc_desc: 'Ghosts scare waiting visitors, boosting patience',
  lnpc_slot: '{cur}/{max} Ghosts',
  evt_time_remaining: '{sec}s remaining',
  evt_rain_name: 'Sudden Rain',
  evt_rain_desc: 'Heavy rain falls suddenly. Visitors without umbrellas are leaving the queue.',
  evt_rain_c1: 'Ignore',
  evt_rain_c2: 'Hand out umbrellas (100 SP)',
  evt_rain_r1: '3 visitors left the queue in the rain.',
  evt_rain_r2: 'Umbrellas were handed out. Everyone stays dry.',
  evt_couple_fight_name: 'Couple Fight',
  evt_couple_fight_desc: 'A couple starts arguing loudly in the queue, disturbing others.',
  evt_couple_fight_c1: 'Handle it',
  evt_couple_fight_r1: 'The situation has been dealt with.',
  evt_crying_child_name: 'Crying Child',
  evt_crying_child_desc: 'A child starts crying in the queue, making others uneasy.',
  evt_crying_child_c1: 'Give candy (50 SP)',
  evt_crying_child_c2: 'Ignore',
  evt_crying_child_r1: 'The candy cheered the child up.',
  evt_crying_child_r2: 'The crying continued, testing everyone\'s patience.',
  evt_blackout_name: 'Power Outage',
  evt_blackout_desc: 'A sudden power outage plunges everything into darkness.',
  evt_blackout_c1: 'Start generator (200 SP)',
  evt_blackout_c2: 'Wait it out',
  evt_blackout_r1: 'The generator kicked in. Business continues.',
  evt_blackout_r2: 'Everyone waited in the dark for a while.',
  evt_line_cutter_name: 'Line Cutter',
  evt_line_cutter_desc: 'Someone brazenly cuts into the front of the queue.',
  evt_line_cutter_c1: 'Call security',
  evt_line_cutter_c2: 'Ignore',
  evt_line_cutter_r1: 'Security escorted the line cutter out.',
  evt_line_cutter_r2: 'Others in line grumble in frustration.',
  evt_fake_ghost_name: 'Fake Ghost Prank',
  evt_fake_ghost_desc: 'A visitor dressed as a ghost is scaring others in line. The crowd seems amused.',
  evt_fake_ghost_c1: 'Let them have fun',
  evt_fake_ghost_r1: 'The prank added to the spooky atmosphere. Reputation up!',
  evt_lost_item_name: 'Lost Item Report',
  evt_lost_item_desc: 'A visitor reports a lost item near the entrance.',
  evt_lost_item_c1: 'Help find it (Reputation +5)',
  evt_lost_item_c2: 'Ignore',
  evt_lost_item_r1: 'The lost item was found! The visitor is grateful.',
  evt_lost_item_r2: 'The visitor left disappointed.',
  evt_snack_sold_out_name: 'Snacks Sold Out',
  evt_snack_sold_out_desc: 'The snack cart ran out of stock. Visitors are asking for snacks.',
  evt_snack_sold_out_c1: 'Emergency restock (100 SP)',
  evt_snack_sold_out_c2: 'Wait for next shipment',
  evt_snack_sold_out_r1: 'Snacks are back in stock.',
  evt_snack_sold_out_r2: 'Visitors will have to wait.',
  evt_sns_selfie_name: 'SNS Photo Op',
  evt_sns_selfie_desc: 'A visitor wants to take a selfie for social media.',
  evt_sns_selfie_c1: 'Acknowledge',
  evt_sns_selfie_r1: 'The post boosted your online presence.',
  evt_hot_weather_name: 'Scorching Heat',
  evt_hot_weather_desc: 'The temperature soars. Visitors look uncomfortable in the heat.',
  evt_hot_weather_c1: 'Free drinks (150 SP)',
  evt_hot_weather_c2: 'Endure it',
  evt_hot_weather_r1: 'Cool drinks refreshed everyone.',
  evt_hot_weather_r2: 'The heat is taking a toll on patience.',
  evt_tour_bus_name: 'Tour Bus Arrival',
  evt_tour_bus_desc: 'A tour bus just arrived! A large group of tourists floods the entrance.',
  evt_tour_bus_c1: 'Welcome them',
  evt_tour_bus_r1: 'The queue fills up with excited tourists.',
  evt_tv_coverage_name: 'TV Crew Request',
  evt_tv_coverage_desc: 'A local TV station wants to cover your haunted house.',
  evt_tv_coverage_c1: 'Accept (risky)',
  evt_tv_coverage_c2: 'Decline',
  evt_tv_coverage_r1: 'The coverage aired. Results vary...',
  evt_tv_coverage_r2: 'You politely declined the offer.',
  evt_spy_name: 'Rival Spy',
  evt_spy_desc: 'You spot someone suspiciously taking notes about your operations.',
  evt_spy_c1: 'Apprehend (need security)',
  evt_spy_c2: 'Ignore',
  evt_spy_r1: 'The spy was caught. You recovered valuable intel.',
  evt_spy_r2: 'Some of your ideas might leak to competitors.',
  evt_health_inspection_name: 'Health Inspection',
  evt_health_inspection_desc: 'Health inspectors arrive for a surprise visit.',
  evt_health_inspection_c1: 'Open the doors',
  evt_health_inspection_r1: 'The inspection is complete.',
  evt_halloween_season_name: 'Halloween Fever',
  evt_halloween_season_desc: 'Halloween spirit fills the air! Everyone is in the mood for scares.',
  evt_halloween_season_c1: 'Celebrate!',
  evt_halloween_season_r1: 'Halloween boost! Extra visitors and SP incoming.',
  evt_ghost_strike_name: 'Ghost Strike',
  evt_ghost_strike_desc: 'Overworked ghosts are refusing to scare. They demand better conditions.',
  evt_ghost_strike_c1: 'Pay bonus (500 SP)',
  evt_ghost_strike_c2: 'Wait it out',
  evt_ghost_strike_r1: 'The bonus satisfied the ghosts. Back to work!',
  evt_ghost_strike_r2: 'The strike continues for a while...',
  evt_mystery_visitor_name: 'Mystery Critic',
  evt_mystery_visitor_desc: 'A famous horror critic is visiting in disguise. Results depend on your reputation.',
  evt_mystery_visitor_c1: 'Best behavior',
  evt_mystery_visitor_r1: 'The critic revealed themselves and wrote a review.',
  evt_maintenance_accident_name: 'Equipment Malfunction',
  evt_maintenance_accident_desc: 'A piece of equipment malfunctioned in one of the rooms!',
  evt_maintenance_accident_c1: 'Assess damage',
  evt_maintenance_accident_r1: 'A room sustained damage. Repairs needed.',
  evt_sns_viral_name: 'Viral Video',
  evt_sns_viral_desc: 'A visitor\'s video of your haunted house went viral online!',
  evt_sns_viral_c1: 'Ride the wave',
  evt_sns_viral_r1: 'Your fame skyrockets! Reputation and SP boosted.',
  evt_total_blackout_name: 'Total Blackout',
  evt_total_blackout_desc: 'All power goes out across the entire area. Complete darkness.',
  evt_total_blackout_c1: 'Candlelight event (+Rep)',
  evt_total_blackout_c2: 'Wait for power',
  evt_total_blackout_r1: 'The candlelight atmosphere was a hit!',
  evt_total_blackout_r2: 'Everyone waited in the dark.',
  evt_famous_youtuber_name: 'Famous Streamer',
  evt_famous_youtuber_desc: 'A famous horror streamer with millions of followers is live-streaming from your haunted house!',
  evt_famous_youtuber_c1: 'Give VIP treatment',
  evt_famous_youtuber_r1: 'The stream was a massive hit! Reputation +30, SP +2000.',
  evt_celeb_visit_name: 'Celebrity Visit',
  evt_celeb_visit_desc: 'A major celebrity has arrived for a private scare session!',
  evt_celeb_visit_c1: 'Roll out the red carpet',
  evt_celeb_visit_r1: 'The celebrity loved it! Huge publicity boost.',
  evt_franchise_offer_name: 'Franchise Offer',
  evt_franchise_offer_desc: 'A corporation wants to franchise your haunted house brand.',
  evt_franchise_offer_c1: 'Accept (10000 SP)',
  evt_franchise_offer_c2: 'Decline',
  evt_franchise_offer_r1: 'Deal signed! A hefty payment arrives.',
  evt_franchise_offer_r2: 'You prefer to stay independent.',
  evt_intl_contest_name: 'International Horror Contest',
  evt_intl_contest_desc: 'Your haunted house is invited to an international scare competition!',
  evt_intl_contest_c1: 'Enter the contest',
  evt_intl_contest_r1: 'You earned recognition on the world stage!',
  evt_documentary_name: 'Documentary Filming',
  evt_documentary_desc: 'A documentary crew wants to film the story of your haunted house.',
  evt_documentary_c1: 'Allow filming',
  evt_documentary_r1: 'The documentary premieres to rave reviews!',
  evt_ghost_king_name: 'The Ghost King Appears',
  evt_ghost_king_desc: 'A legendary ghost is drawn to your haunted house by its fame.',
  evt_ghost_king_c1: 'Welcome the Ghost King',
  evt_ghost_king_r1: 'The Ghost King joins your ranks! Morale soars.',
  evt_gov_subsidy_name: 'Government Grant',
  evt_gov_subsidy_desc: 'The tourism board awards your haunted house a cultural preservation grant.',
  evt_gov_subsidy_c1: 'Accept the grant',
  evt_gov_subsidy_r1: 'Grant received: 5000 SP!',
  evt_vip_party_name: 'VIP Party Request',
  evt_vip_party_desc: 'A wealthy patron wants to rent the entire haunted house for a private party.',
  evt_vip_party_c1: 'Accept (8000 SP)',
  evt_vip_party_c2: 'Decline',
  evt_vip_party_r1: 'The VIP party was a huge success!',
  evt_vip_party_r2: 'You keep the doors open for regular visitors.',
  evt_horror_festival_name: 'Horror Festival',
  evt_horror_festival_desc: 'The city is hosting a horror festival and your haunted house is the main attraction!',
  evt_horror_festival_c1: 'Lead the festival',
  evt_horror_festival_r1: 'The festival was legendary! Massive rewards earned.',
  evt_legendary_review_name: 'Legendary Review',
  evt_legendary_review_desc: 'The world\'s most famous horror critic publishes a glowing review of your haunted house.',
  evt_legendary_review_c1: 'Bask in glory',
  evt_legendary_review_r1: 'A flood of 5-star reviews and fame follows!',

  // === Event Defense System ===
  evt_defense_badge: 'Auto-Resolved!',
  evt_defense_bonus: 'Bonus: +{sp} SP',
  evt_rain_defense: 'The roof upgrade keeps everyone dry. No one leaves!',
  evt_rain_hint: 'Tip: Upgrade Poster Wall to Lv.3 to auto-defend against rain.',
  evt_couple_fight_defense: 'Security steps in and mediates the situation calmly.',
  evt_couple_fight_hint: 'Tip: Hire a Security guard to auto-resolve fights.',
  evt_crying_child_defense: 'The snack cart attendant offers candy. The child smiles!',
  evt_crying_child_hint: 'Tip: Build a Snack Cart to automatically comfort crying children.',
  evt_blackout_defense: 'Emergency generators kick in automatically. No interruption!',
  evt_blackout_hint: 'Tip: Upgrade facilities to total Lv.10+ for backup power.',
  evt_line_cutter_defense: 'Security handles the line cutter immediately. Order restored!',
  evt_line_cutter_hint: 'Tip: Hire a Security guard to auto-handle line cutters.',
  evt_fake_ghost_defense: 'Your real NPC ghosts outshine the impostor. Excitement rises!',
  evt_fake_ghost_hint: 'Tip: Assign at least 1 NPC ghost to the lobby to overshadow fakers.',
  evt_lost_item_defense: 'Your staff quickly locates and returns the lost item!',
  evt_lost_item_hint: 'Tip: Hire 3+ staff members to auto-find lost items.',
  evt_snack_sold_out_defense: 'Inventory auto-restocked from reserves. Sales continue!',
  evt_snack_sold_out_hint: 'Tip: Upgrade Snack Cart to Lv.2+ for auto-restocking.',
  evt_sns_selfie_defense: 'Photo Zone provides the perfect backdrop. Great shots posted!',
  evt_sns_selfie_hint: 'Tip: Build a Photo Zone for automatic photo opportunities.',
  evt_hot_weather_defense: 'The monitor area has air conditioning. Everyone stays cool!',
  evt_hot_weather_hint: 'Tip: Install a TV Monitor to provide a cooled waiting area.',
  evt_tour_bus_defense: 'Plenty of room! All tourists are welcomed in.',
  evt_tour_bus_hint: 'Tip: Expand queue capacity to 15+ to accept large groups.',
  evt_tv_coverage_defense: 'With great reputation and many ghosts, the broadcast is a hit!',
  evt_tv_coverage_hint: 'Tip: Reach reputation 50+ and hire 5+ ghosts for guaranteed success.',
  evt_spy_defense: 'Security catches the spy red-handed! Intel recovered.',
  evt_spy_hint: 'Tip: Hire a Security guard to auto-detect spies.',
  evt_health_inspection_defense: 'Spotless! The inspector awards a hygiene certificate.',
  evt_health_inspection_hint: 'Tip: Hire a Janitor and keep average hygiene above 70.',
  evt_ghost_strike_defense: 'Ghosts are well-rested and happy. No strike today!',
  evt_ghost_strike_hint: 'Tip: Keep average ghost fatigue below 30 to prevent strikes.',
  evt_mystery_visitor_defense: 'Your excellent reputation earns a glowing review!',
  evt_mystery_visitor_hint: 'Tip: Maintain reputation at 60+ for guaranteed good reviews.',
  evt_maintenance_accident_defense: 'The repairman fixes it on the spot. Minimal damage!',
  evt_maintenance_accident_hint: 'Tip: Hire a Repairman to minimize equipment damage.',
  evt_total_blackout_defense: 'Repairman restores power instantly. Candle event bonus!',
  evt_total_blackout_hint: 'Tip: Hire a Repairman and reach facility Lv.15+ total.',
  evt_vip_party_defense: 'Costumes and photo zone make the party unforgettable! Normal business continues too.',
  evt_vip_party_hint: 'Tip: Build Costume Rental and Photo Zone for the ultimate party.',

  // === World Street ===
  world_title: '建築物',
  world_subtitle: '選擇要管理的建築物',
  world_empty_plot: '空地',
  world_build_new: '建造新的主題鬼屋',

  rename_building: '重新命名建築',
  rename_building_desc: '請輸入新的建築名稱',
  rename: '確定',
  building_renamed: '建築名稱已更改！',

  construction_title: '新建築',
  construction_subtitle: '建造新的鬼屋來經營！',
  construction_name_label: '建築名稱',
  construction_name_placeholder: '例: 深夜莊園',
  construction_theme_label: '主題',
  construction_start: '開始建造',
  world_status_build: '建造',
  world_status_open: '營業中',
  world_status_ready: '準備中',
  theme_haunted_house: '鬼屋',
  theme_haunted_house_desc: '經典可愛的鬼屋體驗',
  theme_abandoned_hospital: '廢棄醫院',
  theme_abandoned_hospital_desc: '醫療恐怖和實驗室氛圍',
  theme_school_back_mountain: '學校後山',
  theme_school_back_mountain_desc: '校園鬼故事和山路恐怖氛圍',
  theme_cursed_circus: '詛咒馬戲團',
  theme_cursed_circus_desc: '詛咒馬戲團帳篷的怪誕恐怖',
  theme_ancient_temple: '古寺廟',
  theme_ancient_temple_desc: '古寺廟神秘而陰森的詛咒',
  theme_pirate_ship: '海盜船',
  theme_pirate_ship_desc: '詛咒海盜船的海洋恐怖',
  theme_abandoned_mine: '廢棄礦坑',
  theme_abandoned_mine_desc: '廢棄礦坑深處的黑暗恐怖',
  theme_gothic_castle: '哥德式城堡',
  theme_gothic_castle_desc: '哥德式城堡優雅而陰森的貴族恐怖',
  theme_underground_bunker: '地下碉堡',
  theme_underground_bunker_desc: '地下碉堡的實驗與陰謀恐怖',
  theme_cursed_forest: '詛咒之森',
  theme_cursed_forest_desc: '詛咒之森的自然靈與原始恐怖',

  synergy_active_count: '{n}個協同生效中',
  synergy_popup_title: '生效中的協同',
  syn_fx_dark_mirror_e1: '鏡之幻影',
  syn_fx_dark_mirror_e2: '分身詛咒',
  syn_fx_underground_horror_e1: '地下牢的慘叫',
  syn_fx_underground_horror_e2: '死亡迴響',
  syn_fx_restless_spirits_e1: '亡者嘆息',
  syn_fx_restless_spirits_e2: '幽靈行列',
  syn_fx_creepy_collection_e1: '人偶詛咒',
  syn_fx_creepy_collection_e2: '鏡中迷宮',
  syn_fx_mad_scientist_e1: '瘋狂實驗',
  syn_fx_mad_scientist_e2: '鍊金術報酬',
  syn_fx_hidden_paths_e1: '暗影迷宮',
  syn_fx_hidden_paths_e2: '隱藏恐懼',
  syn_fx_circus_nightmare_e1: '小丑遊戲',
  syn_fx_circus_nightmare_e2: '馬戲團噩夢',
  syn_fx_ancient_curse_e1: '遠古詛咒',
  syn_fx_ancient_curse_e2: '木乃伊之怒',
  syn_fx_hidden_treasures_e1: '寶藏誘惑',
  syn_fx_hidden_treasures_e2: '地下發現',
  syn_fx_ship_of_doom_e1: '海上輓歌',
  syn_fx_ship_of_doom_e2: '戴維瓊斯懲罰',
  syn_fx_prison_horror_e1: '牢獄逃脫',
  syn_fx_prison_horror_e2: '鎖鏈束縛',
  syn_fx_deep_descent_e1: '水晶之光',
  syn_fx_deep_descent_e2: '地下神秘',
  syn_fx_boom_scare_e1: '爆炸餘波',
  syn_fx_boom_scare_e2: '連鎖爆炸',
  syn_fx_royal_terror_e1: '國王之怒',
  syn_fx_royal_terror_e2: '王室寶庫',
  syn_fx_noble_cellar_e1: '陳年酒香',
  syn_fx_noble_cellar_e2: '秘密酒窖',
  syn_fx_quarantine_protocol_e1: '隔離警報',
  syn_fx_quarantine_protocol_e2: '生物危害',
  syn_fx_nature_wrath_e1: '女巫之霧',
  syn_fx_nature_wrath_e2: '大地之怒',
  syn_fx_ancient_power_e1: '遠古之力',
  syn_fx_ancient_power_e2: '神秘遺跡',
  syn_fx_echo_chamber_e1: '回聲詛咒',
  syn_fx_echo_chamber_e2: '聲音幻影',
  syn_fx_water_horror_e1: '深淵恐懼',
  syn_fx_water_horror_e2: '水之低語',
  syn_fx_full_course_e1: '全套盛宴',
  syn_fx_full_course_e2: '滿足微笑',
  synergy_dark_mirror: '暗黑之鏡',
  synergy_dark_mirror_desc: '暗黑走廊 + 鏡子房: 氛圍+15%, 恐懼+10%',
  synergy_underground_horror: '地下恐懼',
  synergy_underground_horror_desc: '地牢/棺材組合: 恐懼+20%, 驚悚+10%',
  synergy_restless_spirits: '不安之靈',
  synergy_restless_spirits_desc: '墓地/棺材/停屍間: 氛圍+20%, 訪客+10%',
  synergy_creepy_collection: '詭異收藏',
  synergy_creepy_collection_desc: '人偶/鏡子/遊樂屋: 恐懼+15%, 驚悚+10%',
  synergy_mad_scientist: '瘋狂科學家',
  synergy_mad_scientist_desc: '實驗室/手術室/科學: 驚悚+20%, SP+15%',
  synergy_hidden_paths: '隱藏路徑',
  synergy_hidden_paths_desc: '密道/走廊/閣樓: 氛圍+15%, 連鎖+20%',
  synergy_circus_nightmare: '馬戲團噩夢',
  synergy_circus_nightmare_desc: '遊樂屋/畸形秀/空中鞦韜: 樂趣+20%, 恐懼+15%',
  synergy_ancient_curse: '古代詛咒',
  synergy_ancient_curse_desc: '祭壇/詛咒室/木乃伊墓: 恐懼+25%, 驚悚+15%',
  synergy_hidden_treasures: '隱藏寰產',
  synergy_hidden_treasures_desc: '寶物庫 + 地下河: SP+20%, 訪客+10%',
  synergy_ship_of_doom: '末日之船',
  synergy_ship_of_doom_desc: '船長室/貨艙/深海: 氛圍+15%, 恐懼+15%',
  synergy_prison_horror: '監獄恐懼',
  synergy_prison_horror_desc: '禁閉室 + 深海: 驚悚+20%, 威脅+10%',
  synergy_deep_descent: '深淵降落',
  synergy_deep_descent_desc: '礦坑/水晶洞/地下湖: 氛圍+20%, 訪客+15%',
  synergy_boom_scare: '爆炸驚悚',
  synergy_boom_scare_desc: '炸藥庫 + 鐵路隧道: 驚悚+25%, 連鎖+15%',
  synergy_royal_terror: '皇家恐懼',
  synergy_royal_terror_desc: '王座/塔樓/酒窖: 恐懼+15%, SP+20%',
  synergy_noble_cellar: '貴族酒窖',
  synergy_noble_cellar_desc: '酒窖 + 密道: 氛圍+15%, SP+10%',
  synergy_quarantine_protocol: '隔離協議',
  synergy_quarantine_protocol_desc: '伺服器室/隔離區/軍械庫: 驚悚+20%, 恐懤+10%',
  synergy_nature_wrath: '自然之怒',
  synergy_nature_wrath_desc: '女巫/沼澤/仙女: 氛圍+20%, 威脅+10%',
  synergy_ancient_power: '古代力量',
  synergy_ancient_power_desc: '遺跡/仙女/祭壇: 恐懤+20%, 訪客+15%',
  synergy_echo_chamber: '迴聍室',
  synergy_echo_chamber_desc: '音樂室/圖書館/走廊: 連鎖+25%, 氛圍+10%',
  synergy_water_horror: '水之恐懼',
  synergy_water_horror_desc: '浴室/地下河/地下湖: 恐懤+15%, 氛圍+15%',
  synergy_full_course: '全套課程',
  synergy_full_course_desc: '廚房/浴室/音樂室: 樂趣+25%, 訪客+20%',
};

export default zhHant;
